customElements.define(
  'code-product-images',
  class CodeProductImages extends HTMLElement {
    async connectedCallback() {
      const { button, activeMediaItem: activeMediaItem = [] } = codeGetTargets(this);

      if (activeMediaItem?.length > 0) {
        activeMediaItem[0].dataset.active = true;

        if (product_media_list.length > 1) {
          button[0].dataset.active = true;
          button.forEach((btn) => {
            btn.addEventListener('click', this.handleButtonClick.bind(this));
          });
        }
      }
    }

    handleButtonClick(event) {
      const { button, activeMediaItem } = codeGetTargets(this);
      const { target } = event;

      button.forEach((btn, index) => {
        btn.toggleAttribute('data-active', btn === target);

        activeMediaItem[index].toggleAttribute('data-active', btn === target);
        if (activeMediaItem[index].dataset.active === undefined) {
          const youtubeIframe = activeMediaItem[index].querySelector('iframe[src*="youtube"]');
          if (youtubeIframe && youtubeIframe.contentWindow) {
            youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }

          const vimeoIframe = activeMediaItem[index].querySelector('iframe[src*="vimeo"]');
          if (vimeoIframe && vimeoIframe.contentWindow) {
            vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }

          const video = activeMediaItem[index].querySelector('video');
          if (video) {
            video.pause();
          }
        } else if (activeMediaItem[index].dataset.active !== undefined) {
          const autoplay = activeMediaItem[index].dataset.autoplay;
          if (autoplay === 'true') {
            activeMediaItem[index].querySelector('video')?.play();
            activeMediaItem[index].querySelector('iframe[src*="youtube"]')?.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            activeMediaItem[index].querySelector('iframe[src*="vimeo"]')?.contentWindow.postMessage('{"method":"play"}', '*');
          }
        }
      });
    }

    disconnectedCallback() {}
  },
);
